import { App, Component,createApp, h, render, VNode } from 'vue';
import { createStore,Store } from 'vuex'
import { CAMPAIGN_STORE } from '@/constants/campaign';
import { State } from '@/store'

type RenderPrefs = {
  component: Component;
  props: any;
  el: Element;
}

export interface ManifoldWindow extends Window {
  [CAMPAIGN_STORE]: Store<{ [key: string]: State }>;
}

const manifoldWindow = (window as Window as ManifoldWindow)

if (manifoldWindow && !manifoldWindow[CAMPAIGN_STORE]) {
  manifoldWindow[CAMPAIGN_STORE] = createStore({
    // plugins: [createDeferrableIdentityVerification()],
    // TODO(chore): enforce strict mode
    // strict: true,
  })
}

/*
 * Returns a functional hook you can call to destroy the vnode
 * Reference: https://vuejs.org/guide/extras/render-function.html#creating-vnodes
 */
export const renderComponentWithVNode = (prefs: RenderPrefs) => {
  let vnode : VNode | undefined = h(prefs.component, prefs.props);
  render(vnode, prefs.el);

  return () => {
    // destroy vnode
    render(null, prefs.el);
    vnode = undefined;
  };
};

/*
 * Returns a functional hook you can call to destroy the component-app
 */
export const renderComponentWithApp = (prefs: RenderPrefs) => {
  let app : App | undefined = createApp(prefs.component, prefs.props);

  // Install the vuex store
  app.use(manifoldWindow[CAMPAIGN_STORE])


  // Mount the app with the root component, its props, and the element to mount to
  app.mount(prefs.el);

  return () => {
    // destroy app with just one component in it
    app?.unmount();
    app = undefined;
  };
};
